<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <Breadcrumbs headline="Sổ điểm" :link="[{ text: 'Số điểm', href: '/marks' }]" />
    </div>

    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <MarkFilter @onFilterChanged="refresh" />
    </v-card>

    <v-card v-show="semesters.length" class="mx-4 elevation-0">
      <div class="pa-4 d-flex justify-end mb-2">
        <v-btn
          v-if="$vuetify.breakpoint.mdAndUp"
          class="mr-2"
          outlined
          color="success"
          @click="() => $refs['excel-export-by-template'].processTemplate()"
        >
          <v-icon left>mdi-file-excel</v-icon>
          <ExcelExportByTemplate
            ref="excel-export-by-template"
            :query="filterParams"
            :studentMarks="studentMarks"
            :factors="factors"
          />
        </v-btn>
      </div>

      <ClassMarkDataTable ref="table" />
    </v-card>
    <MarkBlankView class="mx-4" v-if="!semesters.length" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import MarkFilter from '@/modules/mark/MarkFilter'
import MarkBlankView from '@/modules/mark/MarkBlankView.vue'
import ClassMarkDataTable from '@/modules/mark/ClassMarkDataTable.vue'
import { mapState } from 'vuex'
import ExcelExportByTemplate from '../../modules/mark/class-input/ExcelExportByTemplate.vue'

export default {
  components: {
    Breadcrumbs,
    MarkFilter,
    MarkBlankView,
    ClassMarkDataTable,
    ExcelExportByTemplate
  },
  data() {
    return { filterParams: {} }
  },
  computed: { ...mapState('ClassMark', ['semesters', 'studentMarks', 'factors']) },
  methods: {
    refresh(query) {
      this.filterParams = query
      this.$refs.table.refresh(query)
    },
    exportExcel() {
      // todo
    }
  },
  created() {}
}
</script>
